import { useQuery } from '@tanstack/react-query';

import { accountRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const usePartnerName = () => {
  const query = useQuery({
    queryKey: [QueryKeys.PARTNER_NAME],
    queryFn: () => accountRepo.getPartnerName(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UsePartnerName = ReturnType<typeof usePartnerName>;
